import { type AddTabPanelInfo, TOTAL_DETAIL } from '@/common/stores/slide-detail';
import { DB_TYPE } from '@/common/define/common.define';
import type { ParameterDetailParams } from './types';
import {
  getOracleParameterDetailAddition,
  getPostgresqlParameterDetailAddition,
  getMysqlParameterDetailAddition,
  getSqlServerParameterDetailAddition,
  getTiberoParameterDetailAddition,
  getAltibaseParameterDetailAddition,
  getRedshiftParameterDetailAddition,
  getSinglestoreParameterDetailAddition,
  getClickhouseParameterDetailAddition,
} from './db';
import { InvalidDatabaseTypeError } from './error.utils';

type Params = Omit<ParameterDetailParams, 'dbType'> & { dbType?: string };

export const useParameterDetail = () => {
  const ADDITION_GETTER_OBJ = {
    [DB_TYPE.SQLSERVER]: getSqlServerParameterDetailAddition,
    [DB_TYPE.ORACLE]: getOracleParameterDetailAddition,
    [DB_TYPE.POSTGRESQL]: getPostgresqlParameterDetailAddition,
    [DB_TYPE.MYSQL]: getMysqlParameterDetailAddition,
    [DB_TYPE.TIBERO]: getTiberoParameterDetailAddition,
    [DB_TYPE.ALTIBASE]: getAltibaseParameterDetailAddition,
    [DB_TYPE.CLICKHOUSE]: getClickhouseParameterDetailAddition,
    [DB_TYPE.REDSHIFT]: getRedshiftParameterDetailAddition,
    [DB_TYPE.SINGLESTORE]: getSinglestoreParameterDetailAddition,
  };

  const getParameterDetailAddition = (
    params: Params,
  ): Extract<AddTabPanelInfo, { type: typeof TOTAL_DETAIL.PARAMETER }> => {
    const { dbType = '' } = params;

    const additionGetterFn = ADDITION_GETTER_OBJ[dbType];
    if (!additionGetterFn) {
      throw new InvalidDatabaseTypeError({ dbType });
    }

    const { name, addition } = additionGetterFn(params);
    return {
      type: TOTAL_DETAIL.PARAMETER,
      name,
      addition,
    };
  };

  return { getParameterDetailAddition };
};
